import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    useCurvedTextOnButtons: false
  };
  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.useCurvedTextOnButtons = true;
  }
  return config;
}